import "./WhyResseti.module.css";
import Navigation from "@/reusable_sections/Header";
import Thesis from "./sections/Thesis";
import Methodology from "./sections/Methodology";
import Assessment from "./sections/Assessment";
import Footer from "@/reusable_sections/Footer";
export default function WhyRessetiPage() {
  return <div>
      <Navigation />
      <Thesis />
      <Methodology />
      <Assessment />
      <Footer />
    </div>;
}